<script>
import Loading from '../../components/loading.vue';

export default {
    name: "artistList",
    data() {
        return {
            data: [],
            page: 1,
            allPage: 1,
            isLoading: false,

            detailPath: '',
        };
    },
    computed: {},
    components: {
        Loading
    },
    mounted() {
        // 区分艺术家详情链接 | 形象ip详情链接
        switch (this.$route.path) {
            case '/talents/artist':
                this.detailPath = 'images'
                break;
            case '/talents/ip':
                this.detailPath = 'ipDetail'
                break;
            default:
                break;
        }
        // 
        this.getData();
    },
    destroyed() {},
    watch: {
        '$route.query': {
            handler: function (value) {
                this.data = [];
                this.getData();
            }
        },
    },
    methods: {
        getData() {
            if (this.isLoading) { 
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('getTalentList', {
                category_id: this.$route.query.id,
                limit: 12,
                page: this.page,
                keywords: this.$route.query.s,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.data = this.data.concat(result.data.list);
                    this.allPage = result.data.last_page;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getData();
        }
    },
};
</script>

<template>
    <div class="artist_list layout_main">
        <div class="list flex flex_wrap">
            <router-link class="item" :class="{has_more_cover: item.image2}" v-for="(item, index) in data" :key="index" :to="`${detailPath}?id=${item.id}`">
                <div class="cover_wrap">
                    <div class="cover flex">
                        <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                        <div class="layout_bg bg" v-if="item.image2" :style="`background-image: url(${item.image2});`"></div>
                    </div>
                </div>
                <p class="name">{{ item.name }}</p>
            </router-link>
        </div>
        <Loading v-if="isLoading"/>
        <p class="no_more" v-else-if="data.length == 0">暂无更多内容</p>
        <p class="no_more" v-else-if="page == allPage">已经到底了</p>
        <div class="flex justify_end" v-else>
            <div class="layout_btn_more" @click="getMore">了解更多</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.artist_list{
    padding-bottom: .7rem;
    @media only screen and (max-width: 750px) {
        padding-top: .3rem;
    }
}
.list{
    gap: .2rem;
    @media only screen and (max-width: 750px) {
        gap: .4rem;
        flex-wrap: nowrap;
        flex-direction: column;
    }
    .item{
        width: 2.85rem;
        position: relative;
        // cursor: pointer;
        margin-bottom: .2rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            margin-bottom: 0;
        }
        &.has_more_cover{
            .cover_wrap{
                &:hover{
                    .cover{
                        transform: translate(-50%, 0);
                        @media only screen and (max-width: 750px) {
                            transform: translate(0, 0);
                        }
                    }
                }
            }
        }
        .cover_wrap{
            width: 100%;
            overflow: hidden;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                margin-bottom: .2rem;
            }
            .cover{
                width: 200%;
                position: relative;
                transition: transform .3s;
                .bg{
                    width: 50%;
                    height: 0;
                    padding-bottom: 50%;
                    &.bg2{
                        left: 100%;
                    }
                }
            }
        }
        .name{
            font-size: .18rem;
            text-align: center;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
    }
}
</style>